import React, { Component, Fragment } from 'react'
import { Checkbox } from 'app/assets/icons'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'

const { disabled: disabledColor, grey, text } = colors

type Props = {
    labelKey: string,
    checked?: boolean,
    color?: string,
    labelColor?: string,
    checkedColor?: string,
    onClick?: Function,
    TextStyle?: any,
    disabled?: boolean
}

type State = {
    checked: boolean
}

class Check extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            checked: this.props.checked || false
        }
    }

    handleClick = () => {
        const { onClick } = this.props
        onClick && onClick()
        const checked = !this.state.checked
        this.setState({
            checked
        })
    }

    render() {
        const {
            labelKey,
            labelColor = text,
            color = grey,
            TextStyle = SmallText,
            disabled,
            ...otherProps
        } = this.props

        return (
            <Touchable
                onClick={() => {
                    !disabled && this.handleClick()
                }}
                disabled={disabled}>
                <CheckboxContainer>
                    <Checkbox
                        color={disabled ? disabledColor : color}
                        {...otherProps}
                    />
                </CheckboxContainer>
                <Container>
                    <TextStyle>
                        <FormattedMessage id={labelKey}>
                            {(text: string) => (
                                <TextStyle color={labelColor}>{text}</TextStyle>
                            )}
                        </FormattedMessage>
                    </TextStyle>
                </Container>
            </Touchable>
        )
    }
}

const CheckboxContainer = styled.div`
    margin-right: 10px;
`

const Touchable = styled.div`
    cursor: pointer;
    ${props =>
        props.disabled &&
        `
        cursor: default;
        opacity: 0.8;
    `};
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 10px;
    width: 100%;
`

const Container = styled.div`
    width: 90%;
    padding-top: 2px;
`

export { Check }
